import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { ArrowRight } from "lucide-react";

const EASE = [0.16, 1, 0.3, 1];

const manifesto = [
  { num: "01", title: <>Big <em>sound.</em></>, copy: "A room tuned for bodies in motion — house, techno, hip-hop and everything that makes 2 AM feel early." },
  { num: "02", title: <>Cold <em>pours.</em></>, copy: "A bar that keeps pace with the floor. Signature pours, no queues worth remembering." },
  { num: "03", title: <>Zero <em>ordinary.</em></>, copy: "Good people, great music, and stories you’ll tell twice. That’s the whole dress code." },
];

export const ExperienceSection = () => {
  const imageRef = useRef(null);
  const { scrollYProgress } = useScroll({ target: imageRef, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-9%", "9%"]);
  return (
    <section className="experience" id="experience" data-testid="experience-section">
      <div className="experience-copy">
        <p className="chapter"><b>02</b> Made for the after-hours</p>
        <h2>More than<br/><em>a club.</em></h2>
        <div className="manifesto">
          {manifesto.map((row, i) => (
            <motion.div className="manifesto-row" key={row.num}
              initial={{ opacity: 0, y: 44 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.85, ease: EASE, delay: i * 0.12 }}>
              <span className="num">{row.num}</span>
              <h3>{row.title}</h3>
              <p>{row.copy}</p>
            </motion.div>
          ))}
        </div>
        <a href="#visit" className="text-link" data-testid="experience-visit-link">Come find us <ArrowRight size={15}/></a>
      </div>
      <div className="experience-frame" ref={imageRef}>
        <motion.div className="experience-image" style={{ y }} aria-label="People enjoying a night at Soho Goa" data-testid="experience-image"/>
        <p className="frame-caption">Soho / Floor 01 — Baga</p>
      </div>
    </section>
  );
};
